import { render } from "./LoafingSkeletonCardHours.vue?vue&type=template&id=2d8d02dd&ts=true"
import script from "./LoafingSkeletonCardHours.vue?vue&type=script&lang=ts"
export * from "./LoafingSkeletonCardHours.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__